import React from "react";

export default props => (
    <div className="test-page-content-inner test-page-consent">
        {renderItems(props.content.elems)}
    </div>
);

function renderItems(elems) {
    return elems.map(function (elem, index) {
        return renderItem(elem, index);
    });
}

function renderItem(elem, index) {
    switch (elem.type) {
        case "h1":
            return <h1 key={index}>{elem.text}</h1>;
        case "h2":
            return <h2 key={index}>{elem.text}</h2>;
        case "g":
            return <MessagesList key={index} elems={elem.elems} />;
        default:
            return null;
    }
}

function MessagesList(props) {
    const items = props.elems.map((elem, index) =>
        <li key={index}>{elem.text}</li>
    );
    return (
        <ol>{items}</ol>
    );
}
